/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package core.domain

class UnexpectedErrorException : ApiException(message = "Unexpected error.")